import { SHOW_FORM } from '../actionTypes';
import { productDatasheetsActions } from '../reducer';

export default (value) => productDatasheetsActions[SHOW_FORM](value);
